import { ScrollingModule } from "@angular/cdk/scrolling";
import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA, Type } from "@angular/core";
import { PipesModule } from "@app/_pipes/_pipes.module";
import { CoreDirectivesModule } from "@app/directives/_core/_core.directives.module";
import { FormsDirectivesModule } from "@app/directives/_forms/_form.directives.module";
import { LayoutDirectivesModule } from "@app/directives/_layout/_layout.directives.module";
import { MiscDirectivesModule } from "@app/directives/_misc/_misc.directives.module";
import { CheckboxCell } from "./_components/cells/checkbox-cell/checkbox-cell.component";
import { EnumCellComponent } from "./_components/cells/enum-cell/v-enum-cell.component";
import { VTableHeader } from "./_components/cells/header/v-table-header.component";
import { StackedCell } from "./_components/cells/stacked-cell/stacked-cell.component";
import { DateCell } from "./_components/cells/stacked-date/date-cell.component";
import { StatusCell } from "./_components/cells/status-cell/status-cell.component";
import { VTableCell } from "./_components/cells/v-table-cell.component";
import { VTableComponent } from "./_components/v-table.component";
import { ComponentAnchorDirective } from "./_directives/componentAnchor.directive";
import { VTableActionsComponent } from "./_components/v-table-actions/v-table-actions.component";
import { VTableLayoutContainer } from "./_components/v-table-layout-container/v-table-layout-container.component";
import { VTableColumnEditorComponent } from "./_components/v-table-column-editor/v-table-column-editor.component";
import { TableSummaryBox } from "./_components/visualisations/table-summary-box/table-summary-box.component";
import { RagCellComponent } from "./_components/cells/rag-cell/rag-cell.component";
import { VeriDirectivesModule } from "@app/directives/_veri/_veri.directives.module";
import { ResourceFiltersDirectivesModule } from "@app/directives/_resourceFilters/_resourceFilters.directives.module";
import { PercentageBarCellComponent } from "./_components/cells/percentage-bar/percentage-bar-cell.component";

const privateComponents: Type<any>[] = [
];

const publicComponents: Type<any>[] = [
    VTableLayoutContainer,
    VTableComponent,
    VTableHeader,
    VTableCell,
    StackedCell,
    DateCell,
    CheckboxCell,
    StatusCell,
    EnumCellComponent,
    VTableActionsComponent,
    TableSummaryBox,
    RagCellComponent,
    PercentageBarCellComponent,
    VTableColumnEditorComponent
];


const declarations: any[] = [
    ComponentAnchorDirective
];

@NgModule({
    providers: [

    ],
    imports: [
        CommonModule,
        MiscDirectivesModule,
        CoreDirectivesModule,
        VeriDirectivesModule,
        LayoutDirectivesModule,
        FormsDirectivesModule,
        PipesModule,
        ScrollingModule,
        ResourceFiltersDirectivesModule
    ],
    entryComponents: [...publicComponents, ...privateComponents],
    declarations: [...publicComponents, ...privateComponents, ...declarations],
    exports: [...publicComponents, ...declarations],
    schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class VTableModule {
    constructor() {
    }
}
